//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data () {
    return {
      news: []
    }
  },
  created () {
    this.getNews()
  },
  methods: {
    getNews () {
      this.$store.dispatch('axios/get', { url: '/academy/news', config: { baseURL: process.env.ASYNC_BASE_URL_API } })
        .then((resp) => {
          console.log(process.env.ARZYPTO)
          this.news = resp.data.data
        })
    },
    stripHtml (text) {
      if (!text) { return '' }

      const div = document.createElement('div')
      div.innerHTML = text

      return div.textContent || div.textContent || ''
    },

    formatDate (date) {
      if (!date) { return '' }

      return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }).format(new Date(date))
    }
  }
}
